export const getSavedSearchQueryParams = (url) => {
  return url.replace(`${process.env.API_URL}/api/search`, "");
};
